import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page on route change
  }, [pathname]);

  return null; // No UI needed, just functionality
};

export default ScrollToTop;
